<template>
  <div class="bread_crumb">
    <div class="bread_crumb_inner">
      <a
        v-for="(item, index) in items"
        :key="index"
        :href="item.href"
        :class="{ home: item.isHome }"
      >
        {{ item.text }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
</style>
